import { useEffect, useState } from 'react'
import { ServiceConfig } from '@user/store/services/config'
import { get } from '@user/store/services/crud'
import { defaultGUIDValue } from '@user/components/Dashboard/widgets/utils/constants'
import type { LeadAssignmentRuleFormModel } from '@user/components/Settings/LeadAssignmentRule/LeadAssignmentRuleForm/typings'
import { useGetOptions } from '@user/components/Settings/LeadAssignmentRule/hooks'
import { useGetAssignmentRuleConditions } from '@user/components/Settings/LeadAssignmentRule/LeadAssignmentRuleList/hooks/useGetAssignmentRuleConditions'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.automatedAssignment.automatedAssignment}`

export function useGetAssignmentRule(id?: number) {
  const [assignmentRule, setAssignmentRule] = useState<
    LeadAssignmentRuleFormModel | undefined
  >()
  const getOptions = useGetOptions()
  const getAssignmentRuleConditions = useGetAssignmentRuleConditions()

  useEffect(() => {
    let mounted = true

    if (!id) {
      setAssignmentRule(undefined)
      return
    }

    async function execute() {
      const response = await get(`${baseUrl}/${id}`)

      if (mounted) {
        if (response.ok) {
          const result = await response.json()

          const assignmentRuleConditions = getAssignmentRuleConditions(
            result.assignmentRuleConditions,
            'all',
          )

          setAssignmentRule({
            ...result,
            assignmentRuleConditions,
            ownerId:
              result.ownerId === defaultGUIDValue
                ? 'unassigned'
                : result.ownerId,
          })
        }
      }
    }

    execute()

    return () => {
      mounted = false
    }
  }, [getAssignmentRuleConditions, getOptions, id])

  return { assignmentRule, getOptions }
}
